import React, { useEffect, useRef, useState } from 'react';
import './StackedCards.css';
import useGetUTMData from '../../Hooks/useGetUTMData';
import { useSelector } from 'react-redux';

const featureDetailData = {
  Title: 'Our Amazing Features',
  Features: [
    {
      Title: 'Seamless Integration',
      Description: 'Integrate with your systems quickly and effortlessly.',
      BgColor: '#fbe9e7',
      KeyPoints: ['API Ready', 'Plug & Play', 'No downtime'],
      Image: 'https://via.placeholder.com/400x300?text=Integration',
    },
    {
      Title: 'Smart Automation',
      Description: 'Automate your workflows with intelligent triggers.',
      BgColor: '#e8f5e9',
      KeyPoints: ['Rule-based Engine', 'Event Triggers', 'Zero Manual Effort'],
      Image: 'https://via.placeholder.com/400x300?text=Automation',
    },
    {
      Title: 'Real-time Analytics',
      Description: 'Gain insights in real time with live dashboards.',
      BgColor: '#e3f2fd',
      KeyPoints: ['Live Tracking', 'Custom Reports', 'KPIs'],
      Image: 'https://via.placeholder.com/400x300?text=Analytics',
    },
  ],
};

const StackedCards = () => {

  useGetUTMData();
  const [featureDetailData,setFeatureDetailData] = useState({});
  const data = useSelector((store) => store.data.UTMData)
  useEffect(() => {
      if (data?.items) {
        data.items.forEach((ele) => {
          if (ele.Section === "FeatureDetailSection") {
            setFeatureDetailData(ele.Content)
          }
        }); 
      }
      // console.log("featureDetailData", featureDetailData);
  }, [data]);

  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          } else {
            entry.target.classList.remove('active');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    const slides = containerRef.current.querySelectorAll('.feature-slide');
    slides.forEach((slide) => observer.observe(slide));

    return () => observer.disconnect();
  }, [data]);

  const navigate = (section) => {
    let url = '';
    switch (section) {
      case 'UTM-CONTACT':
        url = '/utm-contact';
       window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        break;
      default:
        console.log(`Unknown section: ${section}`);
        return;
    }
    window.location.href = url;
  };
  return (
    <div className="feature-detail-container" ref={containerRef}>
      <h1 className="text-center mt-5 mb-4 feature-detail-header">
        {featureDetailData.Title}
      </h1>

      <section className="feature-section">
        { (featureDetailData?.Features || []).map((card, i) => (
          <div
            key={i}
            className= {` feature-slide `}
            style={{  backgroundColor: card.BgColor || '#cacaca' , '--index': i }}
          >
            <div
               className= {`content  ${i % 2 !== 0 ? 'reverse' : ''}`} >
              <div className="text-section">
                <h2 className="feature-heading">{card.Title}</h2>
                <p>{card.Description}</p>
                <ul>
                  {card.KeyPoints.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
                <button
                  className="req-demo-btn mt-3"
                  onClick={() => navigate('UTM-CONTACT')}
                >
                  Request a Demo
                </button>
              </div>
              <div className="image-section">
                <img src={card.Image} alt={card.Title} />
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default StackedCards;
